function hasNPS() {
  var element =  document.getElementById('script-indecx');
  if (typeof(element) != 'undefined' && element != null) {
    return true
  }
  return false
}

export function hasAceptedTermsLGPDNps() {
  const privacyPolicy = localStorage.getItem('privacyPolicyFirst');
  const lgpd = localStorage.getItem('lgpd');
  if (privacyPolicy === 'true' && lgpd === 'true') {
    return true;
  }
  return false;
}

export function hasTrainingCompliance() {
  const competitiveCompliance = localStorage.getItem('competitiveCompliance');
  if (hasAceptedTermsLGPDNps() && competitiveCompliance === 'true' ) {
    return true;
  }
  return false
}

export function handleModalNpsRelational() {
  if (hasTrainingCompliance()) {
    return true;
  }
  return false;
}
